export default "__VITE_ASSET__0ZR_fyya__"